import Swal from "sweetalert2/dist/sweetalert2.js";
import { ElNotification } from 'element-plus';
import { SweetAlertIcon, SweetAlertPosition } from "sweetalert2";


export default function () {

    function showNotificationAlert(distribuidor,title, cliente, placa, goTo){	

        var audio = new Audio('./sound/sound.mp3');
        audio.play();

          ElNotification({
            title: title,
            message: cliente + "<br>" + placa,
            dangerouslyUseHTMLString: true,
            type: 'info',
            duration: 3000,
            customClass: "notificacaoToast",
            onClick: goTo
            });
            
            const url = `./distribuidor/icone_${distribuidor}.png`;
            var notification = new Notification(title, { body: "cliente: "+cliente+" placa:"+placa, icon: url });

            notification.onclick = function(event) {
                event.preventDefault(); // prevent the browser from focusing the Notification's tab
                window.focus();
                goTo();
              }
    
    };


    function showConfirmAlert(title, icon = "success", text = "", confirmButtonText = "Ok" , positon = 'top-end'){						
        const Toast = Swal.mixin({
            position: positon as SweetAlertPosition,
            showConfirmButton: true,
            customClass: {
                confirmButton: "bg-none"
            },
            confirmButtonText,
            focusConfirm: false,
        });

        Toast.fire({
            icon: icon as SweetAlertIcon,
            title,
            text
        });
    };

    function showTimeAlert(title, icon = "success"){							
        const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: true,
            timer: 3000,
            timerProgressBar: true,

            onOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer);
                toast.addEventListener('mouseleave', Swal.resumeTimer);
            }
        });

        Toast.fire({
            icon: icon as SweetAlertIcon,
            background: '$cor_indicadores_1',
            title
        });
    };


    return { showConfirmAlert, showTimeAlert, showNotificationAlert };
}